import { render, staticRenderFns } from "./welfare_activity.vue?vue&type=template&id=278de8de&scoped=true"
import script from "./welfare_activity.vue?vue&type=script&lang=js"
export * from "./welfare_activity.vue?vue&type=script&lang=js"
import style0 from "./welfare_activity.vue?vue&type=style&index=0&id=278de8de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278de8de",
  null
  
)

export default component.exports